import React, { useState, useEffect } from 'react'
import { Pane, Switch, TextInputField, Text } from 'evergreen-ui'
import BtnDefault from '../../Components/BtnDefault';
const ExpenseForm = ({
  save, expense = null, update
}) => {
  const [formValues, setFormValues] = useState({
    description: '',
    active: true
  })
  const [isEdit, setEdit] = useState(false)

  useEffect(() => {
    if (expense && !isEdit) {
      setFormValues({
        active: expense.active,
        description: expense.description
      })
      setEdit(true)
    }
  }, [expense, isEdit])

  const handleSave = (e) => {
    e.preventDefault()
    const { description, active } = formValues
    if (isEdit) {
      update({ description, active, __id__: expense.__id__ })
    }
    else {
      save({ description, active })
    }
  }

  const handleChange = ({ target }) => setFormValues({ ...formValues, [target.name]: target.value })

  const { description, active } = formValues
  return (
    <form onSubmit={handleSave}>
      <Pane flex={1} alignItems="center" marginTop={10}>
        <TextInputField
          label='Descrição do Despesa'
          description=""
          name='description'
          placeholder='Descrição'
          value={description}
          onChange={handleChange} />
        <Text>
          Ativo
          <Switch
            name='active'
            height={24}
            checked={active}
            onChange={({ target }) => {
              setFormValues({ ...formValues, [target.name]: target.checked })
            }}
            marginBottom={16}
          />
        </Text>
        <BtnDefault
          disabled={!description}
          onClick={handleSave}
          type='submit'
          iconBefore='tick' height={40} appearance="primary"> {
            !isEdit ? 'Cadastrar' : 'Editar'
          } </BtnDefault>
      </Pane>
    </form>
  )

}

export default ExpenseForm